<template>
  <div>
    <Navigation />
    <div v-if="coinFormShow" class="popUp-overlay"></div>
    <div v-show="coinFormShow" class="popUp-dialog zHelper">
      <div class="col-sm-12">
        <form>
          <div class="row p-1">
            <div class="col-sm-6">
              <div class="form-group has-error has-danger">
                <label class="floatLeft" for="user_name">Username</label>
                <input
                  id="user_name"
                  v-model="user_points.user_name"
                  type="text"
                  name="user_name"
                  class="form-control"
                  data-error="error"
                  readonly
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group has-error has-danger">
                <label class="floatLeft" for="package">Package Type</label>
                <input
                  id="package"
                  v-model="user_points.package_type"
                  type="text"
                  name="package"
                  class="form-control"
                  data-error="error"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="row p-1">
            <div class="col-sm-6">
              <div class="form-group has-error has-danger">
                <label class="floatLeft" for="machine">Machine</label>
                <select
                  v-model="user_points.machine"
                  name="selected_brand"
                  class="custom-select form-control form-control-sm"
                >
                  <option
                    :key="index"
                    v-for="(machine, index) in user_points_machines"
                    v-bind:value="{ id: machine.id }"
                  >
                    {{ machine.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group has-error has-danger">
                <label class="floatLeft" for="greenpoints">Green Points</label>
                <input
                  id="greenpoints"
                  v-model="user_points.points"
                  type="number"
                  name="greenpoints"
                  class="form-control"
                  placeholder
                  required="required"
                  data-error="error"
                />
              </div>
            </div>
          </div>
          <div v-if="errorMsg" class="row">
            <div class="col-md-12">
              <div class="error-infobox">{{ errorMsg }}</div>
            </div>
          </div>
          <div class="row floatLeft">
            <div class="col-md-12">
              <input
                @click.prevent="submit_points()"
                type="submit"
                class="btn btnDark btn-success btn-send pointer"
                value="Submit"
              />
              <input
                v-on:click="close_points_form()"
                type="cancel"
                class="btn btn-secondary pointer button-width-helper"
                value="Cancel"
              />
            </div>
          </div>
        </form>
      </div>
    </div>

    <div v-if="userActivity" class="popUp-overlay"></div>
    <div class="row tableUsers">
      <div v-show="userActivity" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form>
            <div class="messages">
              <div class="controls">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group has-error has-danger">
                      <label class="floatLeft" for="userData"
                        >Export User's activity data</label
                      >
                    </div>
                  </div>
                </div>
                <div class="row floatLeft">
                  <div class="col-md-12">
                    <input
                      v-on:click="downloadFile()"
                      class="btn darkGreen btn-success pointer"
                      value="Download"
                    />
                    <input
                      v-on:click="userActivity = false"
                      type="cancel"
                      class="btn btn-secondary pointer"
                      value="Cancel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="notif_form" class="popUp-overlay"></div>
      <div v-show="notif_form" class="popUp-dialogScrollable zHelper">
        <NotificationsForm
          :message="message"
          v-on:close="notif_form = false"
          @msg="toast_this_ok()"
          @bad="toas_this_bad()"
        ></NotificationsForm>
      </div>
      <div v-if="bannedUser" class="popUp-overlay"></div>
      <div v-show="bannedUser" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form @submit.prevent="submitFunc">
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Are you sure you want to ban this User?</label
                    >
                    <label v-if="errorMsg" class="floatLeft error-infobox">{{
                      errorMsg
                    }}</label>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    v-on:click="bannedUserPost()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="bannedUser = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="unBanUser" class="popUp-overlay"></div>
      <div v-show="unBanUser" class="popUp-dialog zHelper">
        <div class="col-md-12">
          <form @submit.prevent="submitFunc">
            <div class="messages"></div>
            <div class="controls">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group has-error has-danger">
                    <label class="floatLeft" for="form_name"
                      >Are you sure you want to unban this User?</label
                    >
                    <label v-if="errorMsg" class="floatLeft error-infobox">{{
                      errorMsg
                    }}</label>
                    <!-- <input id="form_name" type="text" name="name" class="form-control" placeholder="" required="required" data-error="error"> -->
                  </div>
                </div>
              </div>
              <div class="row floatLeft">
                <div class="col-md-12">
                  <input
                    @submit.prevent
                    v-on:click="unBanUserPost()"
                    type="submit"
                    class="btn danger btnDark btn-success btn-send pointer"
                    value="Yes"
                  />
                  <input
                    v-on:click="unBanUser = false"
                    type="cancel"
                    class="btn btnDark btn-success pointer"
                    value="No"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="toolbar">
              <!-- Here you can write extra buttons/actions for the toolbar -->
            </div>
            <div
              id="datatable_wrapper"
              class="dataTables_wrapper dt-bootstrap4"
            >
              <div class="row">
                <div class="col-sm-12 col-md-2 tableName2">Users</div>
                <div class="col-sm-12 col-md-7 mt-7 text-left">
                  <div
                    class="row pointer mt-1 pl-1"
                    v-on:click="notif_form = true"
                  >
                    <a
                      href="#"
                      class="btn btn-round btn-icon btn-sm createNew mt-1"
                      title="Add new vouchers"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                    <div class="mt-2 ml-2 pt-1">Notify Users</div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3">
                  <div id="datatable_filter" class="dataTables_filter mt-3">
                    <form
                      class="
                        form-inline
                        md-form
                        floatRight
                        searchDiv
                        form-sm
                        active-darkGreen-2
                        mt-2
                      "
                    >
                      <input
                        v-model="search"
                        name="query"
                        v-on:keyup="filterResults()"
                        class="form-control borderNone form-control-sm mr-3"
                        type="text"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row filterbystatus">
                <div class="col-sm-12 col-md-2 mt-1 text-left heading">
                  Filter by status:
                </div>
                <div class="col-sm-12 col-md-5 mt-1 text-left">
                  <input
                    type="checkbox"
                    id="create_action"
                    value="1"
                    v-model="filterStatus"
                    v-on:change="filterResults()"
                  />
                  <label for="create_action">Active</label>
                  <input
                    type="checkbox"
                    id="update_action"
                    value="0"
                    v-model="filterStatus"
                    v-on:change="filterResults()"
                  />
                  <label for="update_action">Not Active</label>
                  <input
                    type="checkbox"
                    id="delete_action"
                    value="2"
                    v-model="filterStatus"
                    v-on:change="filterResults()"
                  />
                  <label for="delete_action">Banned</label>
                </div>
                <div
                  class="col-sm-12 col-md-5 mt-1 text-right heading clearFilter"
                  type="reset"
                >
                  <button @click="ClearFilters()">Clear filters</button>
                </div>
              </div>

              <div
                v-show="hover"
                class="userStatBackground"
                @mouseenter="hover = true"
                @mouseleave="hover = false"
              >
                <div class="row justify-content-center">
                  <table
                    id="datatable"
                    class="
                      table table-striped table-bordered
                      dataTable
                      dtr-inline
                      userStatTable
                    "
                    cellspacing="0"
                    width="100%"
                    role="grid"
                    aria-describedby="datatable_info"
                    style="width: 100%"
                  >
                    <thead>
                      <tr role="row">
                        <th
                          class="sorting_asc"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-sort="ascending"
                          aria-label="Name: activate to sort column descending"
                        >
                          User name
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                        >
                          Date
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                        >
                          Total points
                        </th>
                        <th
                          class="sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 229px"
                          aria-label="Age: activate to sort column ascending"
                        >
                          Earned Points
                        </th>
                        <th
                          class="disabled-sorting sorting"
                          tabindex="0"
                          aria-controls="datatable"
                          rowspan="1"
                          colspan="1"
                          style="width: 230px"
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Spent Points
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        role="row"
                        v-bind:key="index"
                        v-for="(stat, index) in userInfo.stats.slice(0, 6)"
                        v-bind:class="[
                          index % 2 == 0 || index == 0 ? 'even' : 'odd',
                        ]"
                      >
                        <td tabindex="0" class="sorting_1">
                          {{ userInfo.username }}
                        </td>
                        <td>{{ stat.date }}</td>
                        <td>{{ userInfo.currentPoints }}</td>
                        <td>{{ stat.earnPoints }}</td>
                        <td>{{ stat.spentPoints }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="">
                  This view is displaying the last 6 Activities
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 min-table-height">
                <table
                  id="datatable"
                  class="
                    table table-striped table-bordered
                    dataTable
                    dtr-inline
                    m-0
                  "
                  cellspacing="0"
                  width="100%"
                  role="grid"
                  aria-describedby="datatable_info"
                  style="width: 100%"
                >
                  <thead>
                    <tr role="row">
                      <th
                        class="sorting_asc"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-sort="ascending"
                        aria-label="Name: activate to sort column descending"
                        v-on:click="sortResults(1)"
                      >
                        User Name
                      </th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-label="Age: activate to sort column ascending"
                        v-on:click="sortResults(3)"
                      >
                        E-mail
                      </th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-label="Age: activate to sort column ascending"
                        v-on:click="sortResults(4)"
                      >
                        Status
                      </th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-label="Age: activate to sort column ascending"
                        v-on:click="sortResults(2)"
                      >
                        Green Points
                      </th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-label="Age: activate to sort column ascending"
                      >
                        User Activities
                      </th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 229px"
                        aria-label="Age: activate to sort column ascending"
                      >
                        Assign Points
                      </th>
                      <!-- <th
                        class="disabled-sorting text-right sorting"
                        tabindex="0"
                        aria-controls="datatable"
                        rowspan="1"
                        colspan="1"
                        style="width: 230px"
                        aria-label="Actions: activate to sort column ascending"
                      >
                        Actions
                      </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="allalign-items-center"
                      role="row"
                      v-bind:key="index"
                      v-for="(user, index) in users"
                      v-bind:class="[
                        index % 2 == 0 || index == 0 ? 'even' : 'odd',
                      ]"
                    >
                      <td tabindex="0" class="sorting_1">
                        {{ user.username }}
                      </td>
                      <td>{{ user.email }}</td>
                      <td>
                        <span v-if="user.status == 0">Not Active</span>
                        <span v-else-if="user.status == 1"> Active</span>
                        <span v-else>Banned</span>
                      </td>
                      <td>{{ user.greenpoints }}</td>
                      <td>
                        <i
                          class="far fa-file-alt fa-2x"
                          id="latestUserActivity"
                          @mouseenter="showLatestActivities(user.email)"
                          @mouseleave="hover = false"
                          @mouseup="
                            userActivity = true;
                            hover = false;
                          "
                        ></i>
                      </td>
                      <td>
                        <i
                          class="fas fa-coins fa-2x pointer"
                          id="UserAssignPoints"
                          v-on:click="assign_points(user)"
                        ></i>
                        <label class="activity_label" for="delete"
                          >Assign points
                        </label>
                      </td>
                      <!-- <td class="text-right pb-0 pr-0">
                        <div
                          class="actions_on_user pr-2"
                          v-if="user.status != 2"
                        >
                          <a
                            href="#"
                            class="btn btn-round btn-danger btn-icon btn-sm remove mr-2"
                            v-on:click="
                              bannedMessage();
                              banUserId = user.id;
                            "
                            id="banUser"
                          >
                            <i class="fas fa-ban pad-2px-helper"></i>
                          </a>
                          <label class="activity_label" for="banUser"
                            >Ban user</label
                          >
                        </div>
                        <div class="actions_on_user pr-2" v-else>
                          <a
                            href="#"
                            class="btn btn-round btn-success btn-icon btn-sm remove mr-2"
                            v-on:click="
                              unBanMessage();
                              banUserId = user.id;
                            "
                            id="unBanUser"
                          >
                            <i class="fas fa-user-check"></i>
                          </a>
                          <label class="activity_label" for="unBanUser"
                            >Unban user</label
                          >
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <pagination
              :meta_data="meta_data"
              v-on:next="fetchResults"
            ></pagination>
          </div>
        </div>
        <!-- end content-->
      </div>
      <!--  end card  -->
    </div>
    <!-- end col-md-12 -->
  </div>
</template>

<script>
//  TODO IMPLEMET TO DOWNLOAD THE FILE AND TO make to hover next to the item. . .
import axios from "axios";
import Navigation from "@/views/Navigation.vue";
import Pagination from "@/components/Pagination.vue";
import NotificationsForm from "@/components/NotificationsForm.vue";
import store from "./../store/index";
export default {
  components: {
    Navigation,
    Pagination,
    NotificationsForm,
  },
  data() {
    return {
      message: "",
      hover: false,
      notif_form: false,
      userActivity: false,
      coinFormShow: false,
      bannedUser: false,
      unBanUser: false,
      banUserId: "",
      users: [],
      search: null,
      sort: null,
      order: null,
      errorMsg: "",
      dir: 0,
      filterStatus: [],
      userInfo: {
        username: null,
        currentPoints: null,
        stats: [],
        activityDate: null,
        earnPoints: null,
        spentPoints: null,
      },
      meta_data: {
        last_page: null,
        current_page: 1,
        prev_page_url: null,
        perpage: 5,
        total: 0,
      },
      user_points_machines: [],
      user_points: {
        user_id: null,
        user_name: null,
        package_type: "Undefined",
        points: 0,
        machine: [],
      },
    };
  },
  created() {
    console.log(this.$route.params.data);
    this.filterStatus.push(this.$route.params.data);
  },
  mounted() {
    this.checkPath();
    this.fetchResults(
      this.meta_data.current_page,
      this.meta_data.perpage,
      this.search,
      this.order,
      this.sort,
      this.type,
      this.filterStatus
    );
  },
  methods: {
    bannedMessage() {
      this.$data.bannedUser = true;
    },
    unBanMessage() {
      this.$data.unBanUser = true;
    },
    bannedUserPost() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );
      axios
        .post(store.state.BASE_URI + "admin/users/ban_user", {
          params: {
            userId: this.banUserId,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.fetchResults();
          this.$data.bannedUser = false;
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
          }
        });
    },
    unBanUserPost() {
      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );
      axios
        .post(store.state.BASE_URI + "admin/users/unban_user", {
          params: {
            userId: this.banUserId,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.fetchResults();
          this.$data.unBanUser = false;
          // TODO: add toast notification
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
          }
        });
    },
    fetchResults(
      page = this.meta_data.current_page,
      perpage = this.meta_data.perpage,
      search = this.search,
      order = this.order,
      sort = this.sort,
      total = this.meta_data.total,
      type = this.type,
      status = this.filterStatus
    ) {
      axios
        .get(store.state.BASE_URI + "admin/users/load_users", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            page,
            perpage,
            search,
            order,
            sort,
            total,
            type,
            status,
          },
        })
        .then((res) => {
          this.users = res.data.results.users;
          var pagination = res.data.results.pagination;
          this.meta_data.last_page = pagination.last_page;
          this.meta_data.current_page = pagination.current_page;
          this.meta_data.prev_page_url = pagination.prev_page_url;
          this.meta_data.perpage = pagination.perpage;
          this.meta_data.search = pagination.search;
          this.meta_data.total = pagination.total;
        });
    },
    sortResults(order) {
      this.dir++;
      this.order = order;

      if (this.dir % 2 == 0) {
        this.sort = "desc";
      } else {
        this.sort = "asc";
      }
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.type,
        this.filterStatus
      );
    },
    filterResults() {
      this.meta_data.current_page = 1;
      this.fetchResults(
        this.meta_data.current_page,
        this.meta_data.perpage,
        this.search,
        this.order,
        this.sort,
        this.type,
        this.filterStatus
      );
    },
    downloadActivities() {
      this.userActivity = false;
    },
    showLatestActivities(Useremail = null) {
      this.hover = true;
      axios
        .get(store.state.BASE_URI + "admin/users/load_user_activity", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {
            email: Useremail,
          },
        })
        .then((res) => {
          //  console.log(res.data.results);
          this.userInfo.username = res.data.results.userInfo.username;
          this.userInfo.currentPoints = res.data.results.userInfo.currentPoints;
          this.userInfo.stats = res.data.results.stats;
        });
    },
    downloadFile(email) {
      getReport(email, this.userInfo);
      this.userActivity = false;
    },
    checkPath() {
      let path = this.$route.path.split("/");
      let res = path[path.length - 1];
      console.log(res);
      if (res === "total") {
        this.filterStatus = [];
      } else if (res === "active") {
        this.filterStatus.push(1);
      } else if (res === "nonactive") {
        this.filterStatus.push(0);
      } else if (res === "banned") {
        this.filterStatus.push(2);
      }
    },
    getAllMachines() {
      axios
        .get(store.state.BASE_URI + "admin/machines/load_all_machines", {
          headers: { Authorization: localStorage.getItem("accessToken") },
          params: {},
        })
        .then((res) => {
          this.user_points_machines = res.data.results;
        });
    },
    assign_points(user) {
      this.user_points.user_id = user.id;
      this.user_points.user_name = user.username;
      this.coinFormShow = true;

      this.getAllMachines();
    },
    submit_points() {
      console.log(this.user_points);
      console.log(this.user_points_machines);
      if (
        this.user_points.machine.length < 1 ||
        this.user_points.points.length == 0
      ) {
        this.$toasted
          .show("Полињата Machine и points не може да бидат празни.", {
            type: "error",
          })
          .goAway(5000);
        // this.close_points_form();
        return;
      }

      axios.defaults.headers.common["Authorization"] = localStorage.getItem(
        "accessToken"
      );
      axios
        .post(store.state.BASE_URI + "admin/users/assign_points", {
          params: {
            user_id: this.user_points.user_id,
            machine_id: this.user_points.machine.id,
            points: this.user_points.points,
          },
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
        })
        .then((response) => {
          this.fetchResults();
          this.close_points_form();
          this.$toasted
            .show(response.data.message, { type: "success" })
            .goAway(2000);
        })
        .catch((error) => {
          if (error) {
            this.errorMsg = error.response.data.message;
            this.$toasted
              .show(this.errorMsg, {
                type: "error",
              })
              .goAway(2000);
            this.close_points_form();
          }
        });
    },
    close_points_form() {
      this.coinFormShow = false;
      this.user_points.user_id = this.user_points.user_name = null;
      this.user_points.points = 0;
      this.coinFormShow = false;
      this.user_points.machine = [];
      this.user_points_machines = [];
    },
    ClearFilters() {
      (this.meta_data.current_page = 1),
        (this.meta_data.perpage = 5),
        (this.search = null),
        (this.order = null),
        (this.sort = null),
        (this.type = null),
        (this.filterStatus = []),
        this.fetchResults(
          this.meta_data.current_page,
          this.meta_data.perpage,
          this.search,
          this.order,
          this.sort,
          this.type,
          this.filterStatus
        );
    },
    //  toast_this_ok() {
    //    this.$toasted
    //      .show('Succeffuly notified users', { type: 'success' })
    //      .goAway(2000);
    //  },
    //  toast_this_bad() {
    //    this.$toasted
    //      .show('Failed to notify users, please try again', { type: 'error' })
    //      .goAway(2000);
    //  },
  },
  computed: {
    //    users() {
    //      return this.$store.getters.getUsers;
    //    },
  },
  created() {
    //    this.$store.dispatch('fetchUsers')
  },
};
const objectToCsv = function(data) {
  console.log(data);
  const csvRows = [];

  // add username
  const headers = ["Username", data.username];

  csvRows.push(headers.join(","));

  csvRows.push(["\n"].join(","));

  // add statistics

  const headers2 = ["Activity", "Machine", "Points", "Date"];
  csvRows.push(headers2.join(","));
  for (const row of data.stats) {
    const values2 = [
      row.activity,
      row.machine,
      row.spentPoints === 0 ? row.earnPoints : "-" + row.spentPoints,
      row.date,
    ];
    csvRows.push(values2.join(","));
  }

  csvRows.push(["\n"].join(","));

  // add available points
  const headers1 = ["Total Available points", data.currentPoints];
  csvRows.push(headers1.join(","));

  return csvRows.join("\n");
};
const download = function(data, fileName) {
  const blob = new Blob([data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("hidden", "");
  a.setAttribute("href", url);
  a.setAttribute("download", fileName + ".csv");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
const getReport = async function(email, userInfo) {
  const res = userInfo;
  const csvData = objectToCsv(res);
  //  console.log(csvData);
  download(csvData, userInfo.username);
};
</script>

<style src="../css/style.css"></style>
